import api from '@/lib/api';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'ref'];

export const captureUtm = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    UTM_KEYS.forEach((k) => { const v = params.get(k); if (v) found[k] = v.slice(0, 120); });
    if (Object.keys(found).length) {
      const prev = JSON.parse(localStorage.getItem('veluro_utm') || '{}');
      localStorage.setItem('veluro_utm', JSON.stringify({ ...prev, ...found }));
    }
  } catch { /* ignore */ }
};

export const getUtm = () => {
  try { return JSON.parse(localStorage.getItem('veluro_utm') || '{}'); } catch { return {}; }
};

export const getDemandSession = () => localStorage.getItem('veluro_demand_session') || '';
export const setDemandSession = (id) => localStorage.setItem('veluro_demand_session', id);

export const track = (event, meta = {}) => {
  try {
    api.post('/public/track', {
      event, session_id: getDemandSession(), utm: getUtm(),
      meta: { ...meta, path: window.location.pathname },
    }).catch(() => {});
  } catch { /* ignore */ }
};
